import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { isMobile } from '@pascal/pascal-core';
import Button from './button';
import { userInfoStore } from '../../../../store/userInfoStore';
import { useAmountValidation } from '../../../../hooks/useAmountValidation';
import { regexByPrecision } from '../../../../core/helpers/regexByPrecision';
import { kenoBetStore } from '../../../../store/kenoBetStore';
import useTranslation from '../../../../hooks/useTranslation';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { applicationStore } from '../../../../store/applicationStore';
import { useBalance } from '../../../../hooks/useBalance';

export const AmountBlock = observer(() => {
  const {
    betAmount,
    setBetAmount,
    setDouble,
    setHalve,
    limits,
    increaseAmount,
    userBalance,
    precision,
  } = userInfoStore;
  const { demoBalance, isDemo } = applicationStore;

  const { isBetsClosed, isOpenNumpad } = kenoBetStore;
  const t = useTranslation();

  const balance = useBalance(isDemo, demoBalance, userBalance);

  const handleChangeBetAmount = useCallback(
    ({ changeBet }) => {
      setBetAmount(changeBet);
    },
    [setBetAmount]
  );

  const handleMaxBet = useCallback(() => {
    if (balance < limits?.maxBet) {
      if (balance > limits.minBet) {
        setBetAmount(balance);
      }
    } else {
      setBetAmount(limits?.maxBet);
    }
  }, [balance, setBetAmount, limits]);

  const handleBlurBetAmount = useCallback(() => {
    if (limits.maxBet < +betAmount) {
      setBetAmount(limits.maxBet);
    }
    if (limits.minBet > +betAmount) {
      setBetAmount(limits.minBet);
    }
  }, [betAmount, limits, setBetAmount]);

  const { onChange: handleChangeInput } = useAmountValidation(
    handleChangeBetAmount,
    limits,
    regexByPrecision(precision)
  );

  const handleIncreaseAmount = useCallback(
    (isIncrease) => {
      increaseAmount(isIncrease);
    },
    [increaseAmount]
  );

  const handleClickBetAmountInput = useCallback(
    (e) => {
      if (isMobile()) {
        e.stopPropagation();
        document.activeElement.blur();
        kenoBetStore.setIsOpenNumpad(!isOpenNumpad);
      }
    },
    [isOpenNumpad]
  );

  return (
    <div className='keno-bet-calc-block'>
      <div className='keno-bet-calc-field-block'>
        <div className='keno-bet-calc-field'>
          {/* <div className='input-calc-action '></div> */}
          <button
            type='button'
            className={`calc-action-btn icon-rounded-minus minus-action ${
              limits?.minBet === +betAmount || isBetsClosed ? 'disabled' : ''
            }`}
            onClick={() => handleIncreaseAmount(false)}
          >
            <span className='btn-txt-label'>Minus action</span>
          </button>
          {/* <div className='input-calc-action plus-action'></div> */}
          <button
            type='button'
            className={`calc-action-btn plus-action icon-rounded-plus ${
              limits?.maxBet === +betAmount || isBetsClosed ? 'disabled' : ''
            }`}
            onClick={() => handleIncreaseAmount(true)}
          >
            <span className='btn-txt-label'>Plus action</span>
          </button>
          <input
            type='text'
            className={`keno-bet-calc-input ${isBetsClosed ? 'disabled' : ''}`}
            value={betAmount || ''}
            onBlur={handleBlurBetAmount}
            onChange={handleChangeInput}
            onClick={handleClickBetAmountInput}
          />
        </div>

        <div className='keno-bet-calc-type'>
          <Button
            text='1/2'
            handleClick={setHalve}
            isDisabled={limits?.minBet === +betAmount || isBetsClosed}
          />
          <Button
            text='x2'
            handleClick={setDouble}
            isDisabled={limits?.maxBet === +betAmount || isBetsClosed}
          />
          <Button
            text={t(TranslationKeys.Max)}
            handleClick={handleMaxBet}
            isDisabled={limits?.maxBet === +betAmount || isBetsClosed}
          />
        </div>
      </div>
    </div>
  );
});
